import { useEffect, useState } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";
import { api } from "./lib/api";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import ComingSoon from "./pages/ComingSoon";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";

export default function AppRoutes() {
  const [siteOpen, setSiteOpen] = useState(null);
  const [searchParams] = useSearchParams();
  const preview = searchParams.get("preview") === "1";

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSiteOpen(!!r.data.site_open))
      .catch(() => setSiteOpen(true));
  }, []);

  if (siteOpen === null) {
    return <div className="min-h-screen bg-black" />;
  }

  const PublicPage = siteOpen || preview ? <Landing /> : <ComingSoon />;

  return (
    <Routes>
      <Route path="/" element={PublicPage} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/checkout/cancel" element={<CheckoutCancel />} />
    </Routes>
  );
}
